import { render, staticRenderFns } from "./FieldType4.vue?vue&type=template&id=3c2e03b8&scoped=true"
import script from "./FieldType4.vue?vue&type=script&lang=js"
export * from "./FieldType4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e03b8",
  null
  
)

export default component.exports